var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/info-menu/InfoMenu.tsx",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext, useState } from 'react';
import { safeRest } from '@wds/utils';
import { getClientEnvironmentDetails } from '@sm/utils';
import { Accordion } from '@wds/accordion';
import { Responsive } from '@wds/responsive';
import { List } from '@wds/list';
import { t, defineMessages } from '@sm/intl';
import { MetricsTracker, USER_EVENTS } from '@sm/metrics';
import ProductsMenu from './ProductsMenu';
import HelpMenu from './HelpMenu';
import Notifications from './Notifications';
import useStyles from './useStyles';
import HeaderContext from '../../HeaderContext';
var COPY = defineMessages({
  HELP: {
    id: 'InfoMenu.help',
    defaultMessage: 'Help',
    description: '[Type: Label][Vis.: high] - This is the Help title of the side menu.'
  },
  PRODUCTS: {
    id: 'InfoMenu.products',
    defaultMessage: 'Products',
    description: '[Type: Label][Vis.: high] - This is the Products title of the side menu.'
  }
});
var InfoMenu = function InfoMenu(_ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var classes = useStyles();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showProducts = _useState2[0],
    setShowProducts = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showHelp = _useState4[0],
    setShowHelp = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showNotifications = _useState6[0],
    setShowNotifications = _useState6[1];
  var _getClientEnvironment = getClientEnvironmentDetails(),
    isDesktop = _getClientEnvironment.isDesktop;
  var _useContext = useContext(HeaderContext),
    pageURL = _useContext.pageURL,
    pageName = _useContext.pageName;
  var TrackMenuEvents = function TrackMenuEvents(menuName, opened) {
    MetricsTracker.track({
      name: USER_EVENTS.ELEMENT_INTERACTION,
      data: {
        url: pageURL,
        pageName: pageName,
        amplitudeEvent: 'header clicked menu',
        menuName: menuName,
        opened: opened
      }
    });
  };
  var toggleProducts = function toggleProducts() {
    setShowHelp(false);
    setShowNotifications(false);
    setShowProducts(!showProducts);
    TrackMenuEvents('product', !showProducts);
  };
  var toggleHelp = function toggleHelp() {
    setShowProducts(false);
    setShowNotifications(false);
    setShowHelp(!showHelp);
    TrackMenuEvents('help center', !showHelp);
  };
  var toggleNotifications = function toggleNotifications() {
    setShowProducts(false);
    setShowHelp(false);
    setShowNotifications(!showNotifications);
    TrackMenuEvents('notifications', !showNotifications);
  };
  if (showHelp || showProducts || showNotifications) {
    document.body.style.overflowY = 'hidden';
  } else {
    document.body.style.overflowY = 'auto';
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Responsive, {
    defaultMatches: !isDesktop,
    minWidth: "xl",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", Object.assign({
    className: classes.infoMenu
  }, safeRest(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(ProductsMenu, {
    showProducts: showProducts,
    toggleProducts: toggleProducts,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement("div", Object.assign({
    className: classes.infoMenu
  }, safeRest(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(Notifications, {
    showNotifications: showNotifications,
    toggleNotifications: toggleNotifications,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement("div", Object.assign({
    className: classes.infoMenu
  }, safeRest(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(HelpMenu, {
    showHelp: showHelp,
    toggleHelp: toggleHelp,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 13
    }
  })))), /*#__PURE__*/React.createElement(Responsive, {
    defaultMatches: !isDesktop,
    maxWidth: "xl",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Accordion, {
    noRules: true,
    interactive: true,
    onChange: toggleProducts,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Notifications, {
    showNotifications: showNotifications,
    toggleNotifications: toggleNotifications,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(Accordion.Item, {
    title: t(COPY.PRODUCTS),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 107,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(List, {
    noRules: true,
    interactive: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(ProductsMenu, {
    showProducts: showProducts,
    toggleProducts: toggleProducts,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 109,
      columnNumber: 17
    }
  })))), /*#__PURE__*/React.createElement(Accordion, {
    noRules: true,
    interactive: true,
    onChange: toggleHelp,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 116,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Accordion.Item, {
    title: t(COPY.HELP),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(List, {
    noRules: true,
    interactive: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(HelpMenu, {
    showHelp: showHelp,
    toggleHelp: toggleHelp,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 17
    }
  })))))));
};
export default InfoMenu;
export { InfoMenu };
//# sourceMappingURL=InfoMenu.js.map